import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as AddIcon } from '../../icons/Add.svg';
import classes from './EmployerLayout.module.css';
import { useAppSelector } from '../../hooks';

const AddNewPositionButton: FC = () => {
  const [t] = useTranslation('global');
  const { serverInternal } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const backgroundColor = serverInternal
    ? 'var(--primary-green)'
    : 'var(--brand-blue-100)';

  const onClick = () => {
    if (serverInternal) navigate('/internal-dashboard/add-position');
    else navigate('/employer-dashboard/add-position');
  };

  return (
    <div
      className={classes.NewJob}
      role="button"
      style={{
        backgroundColor,
      }}
      data-testid="add-new-position-button"
      onClick={onClick}
      onKeyDown={onClick}
      tabIndex={0}
    >
      <p className={classes.NewJobText}>{t('EmployerDashboard.AddNewJob')}</p>
      <AddIcon />
    </div>
  );
};

AddNewPositionButton.defaultProps = {
  openModal: () => {},
};

export default AddNewPositionButton;
